export class DealerBillingDetail {
	onPay: number;
	onOrder: number;
	kitchen: number;
	datafeed: number;
	onlineorder: number;
	scheduling: number;
	transact: number;

	public constructor(init?: Partial<DealerBillingDetail>) {
		Object.assign(this, init);
	}
}

export class DealerBillingCount {
	onPayLicenses: number;
	onPayPacks: number;
	onOrderLicenses: number;
	onOrderPacks: number;
	kitchen: number;
	datafeed: number;
	onlineorder: number;
	scheduling: number;
	transact: number;
	connector: number;
	active: number;
	inactive: number;
	demo: number;

	public constructor(init?: Partial<DealerBillingCount>) {
		Object.assign(this, init);
	}
}
